import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminProveedoresPage } from "@/features/admin-proveedores/components/AdminProveedoresPage";
import { proveedoresAdminQueryOptions } from "@/features/admin-proveedores/hooks/use-proveedores-admin";

export const Route = createFileRoute("/_authed-tw/admin/proveedores")({
  // Precarga la primera página (params default del componente) · el primer
  // paint es síncrono; filtros/páginas posteriores se fetchean on-demand.
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(proveedoresAdminQueryOptions({ page: 1, pageSize: 15 })),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminProveedores]}>
      <AdminProveedoresPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
